module.exports = __webpack_public_path__ + "media/images/review/ico-review-crown-a0af63b88790b31cae79cb9095bd93b2.svg";